// import React from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import axios from "axios";
// import "./Css/View.css";
// import profile from "./Images/Ellipse 24 (4).png"

// const InstitudeSoftView = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const handleEditClick = (index) => {
//     navigate("/dashboard/institudesoftedit");
//   };

//   return (
//     <div className="student-page">
//       {/* Header */}
//       <div className="page-header">
//         <h3 style={{ cursor: "pointer" }}
//           onClick={() => navigate(-1)}>
//           संस्था व्यवस्थापन &gt;&gt; तपशील&gt;&gt; सॉफ्टवेअर माहिती&gt;&gt; <span>सॉफ्टवेअर तपशील</span>
//         </h3>
//         <button className="edit-btn" onClick={() => handleEditClick()} >एडिट करा</button>
//       </div>
//       <p>संस्थेचे नाव: <strong>ज्ञानदीप इंग्लिश स्कूल </strong></p>

//       <h2>सॉफ्टवेअर तपशील</h2>
//       <div className="profile-card">
//         <img
//           src={profile}
//           alt="student"
//           className="profile-img"
//         />
//         <p>पूर्व माध्यमिक शिष्यवृत्ती परीक्षा सॉफ्टवेअर</p>
//       </div>

//       {/* Info Grid */}
//       <div className="info-grid">
//         <div className="info-box">
//           <label>परीक्षा नाव</label>
//           <p>पूर्व उ. प्रा. शिष्यवृत्ती परीक्षा</p>
//         </div>

//         <div className="info-box">
//           <label>खरेदी दिनांक</label>
//           <p>१०/१२/२०२६ </p>
//         </div>

//         <div className="info-box">
//           <label>सॉफ्टवेअर पॅकेज नाव</label>
//           <p>Basic</p>
//         </div>

//         <div className="info-box">
//           <label>किंमत</label>
//           <p>1500</p>
//         </div>

//         <div className="info-box">
//           <label>पेमेंट स्टेटस</label>
//           <p>पेमेंट झाल आहे </p>
//         </div>

//         <div className="info-box">
//           <label>कालावधी </label>
//           <p>२ महिने </p>
//         </div>

//         <div className="info-box">
//           <label>स्टुडंट लिमिट</label>
//           <p>२० विद्यार्थी </p>
//         </div>

//         <div className="info-box">
//           <label>समाप्ती तारीख</label>
//           <p>१०/०२/२०२६</p>
//         </div>

//         <div className="info-box">
//           <label>नूतनीकरण तारीख</label>
//           <p>१०/०२/२०२६</p>
//         </div>
//       </div>


//     </div>
//   );
// };

// export default InstitudeSoftView;



import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import "./Css/View.css";
import profile from "./Images/Ellipse 24 (4).png";
import API_BASE from "../config/api";

const InstitudeSoftView = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [software, setSoftware] = useState(null);

  useEffect(() => {
    if (!id) return;

    axios
      .get(`${API_BASE}/api/Institutes/software/${id}`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
        }
      })
      .then((res) => {
        setSoftware(res.data);
        console.log(res.data, "software detail");
      })
      .catch((err) => {
        console.error("Failed to load software details", err);
      });
  }, [id]);

  const handleEditClick = () => {
    navigate(`/dashboard/institudesoftedit/${id}`);
  };

  if (!software) {
    return <div className="student-page">Loading...</div>;
  }

  return (
    <div className="student-page">
      {/* Header */}
      <div className="page-header">
        <h3
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        >
          संस्था व्यवस्थापन &gt;&gt; तपशील&gt;&gt; सॉफ्टवेअर माहिती&gt;&gt;{" "}
          <span>सॉफ्टवेअर तपशील</span>
        </h3>
        <button className="edit-btn" onClick={handleEditClick}>
          एडिट करा
        </button>
      </div>

      <p>
        संस्थेचे नाव: <strong>{software.instituteName}</strong>
      </p>

      <h2>सॉफ्टवेअर तपशील</h2>

      <div className="profile-card">
        <img
          src={
            software.profilePictureUrl
              ? software.profilePictureUrl
              : profile
          }
          alt="software"
          className="profile-img"
        />
        <p>{software.softwareName}</p>
      </div>

      {/* Info Grid */}
      <div className="info-grid">
        <div className="info-box">
          <label>परीक्षा नाव</label>
          <p>{software.softwareName}</p>
        </div>

        <div className="info-box">
          <label>खरेदी दिनांक</label>
          <p>
            {software.purchaseDate &&
              software.purchaseDate !== "0001-01-01T00:00:00"
              ? new Date(software.purchaseDate).toLocaleDateString("en-GB")
              : "--"}
          </p>
        </div>

        <div className="info-box">
          <label>सॉफ्टवेअर पॅकेज नाव</label>
          <p>{software.subscriptionType}</p>
        </div>

        <div className="info-box">
          <label>किंमत</label>
          <p>₹{software.softwarePrice}</p>
        </div>

        <div className="info-box">
          <label>पेमेंट स्टेटस</label>
          <p>पेमेंट झाल आहे</p> {/* Hardcoded */}
        </div>

        <div className="info-box">
          <label>कालावधी </label>
          <p>{software.duration}</p>
        </div>

        <div className="info-box">
          <label>स्टुडंट लिमिट</label>
          <p>{software.studentCapacity} विद्यार्थी</p> {/* Hardcoded */}
        </div>

        <div className="info-box">
          <label>समाप्ती तारीख</label>
          <p>
            {software.softwareEndDate &&
              software.softwareEndDate !== "0001-01-01T00:00:00"
              ? new Date(software.softwareEndDate).toLocaleDateString("en-GB")
              : "--"}
          </p>
        </div>

        <div className="info-box">
          <label>नूतनीकरण तारीख</label>
          <p>
            {software.softwareEndDate &&
              software.softwareEndDate !== "0001-01-01T00:00:00"
              ? new Date(software.softwareEndDate).toLocaleDateString("en-GB")
              : "--"}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InstitudeSoftView;
